import script from "./Comments.vue?vue&type=script&lang=ts&setup=true"
export * from "./Comments.vue?vue&type=script&lang=ts&setup=true"

import "./Comments.vue?vue&type=style&index=0&id=20c10cac&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20c10cac"]])

export default __exports__